// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connect-accounts {
  min-height: calc(100vh - 140px);
  padding: 40px;
  background: #f8fafc;
}

.connect-accounts-header {
  text-align: center;
  margin-bottom: 60px;
}

.connect-accounts-header h1 {
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 12px;
}

.connect-accounts-header p {
  font-size: 16px;
  color: #6b7280;
  max-width: 600px;
  margin: 0 auto;
  line-height: 1.6;
}

.platforms-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 60px;
  margin-bottom: 40px;
  max-width: 1000px;
  margin-left: auto;
  margin-right: auto;
}

.platform-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.platform-logo {
  width: 120px;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e5e7eb;
}

.platform-logo img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.connect-button {
  padding: 12px 32px;
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  min-width: 120px;
}

.connect-button.primary {
  background: #3b82f6;
  color: white;
}

.connect-button.primary:hover {
  background: #2563eb;
}

.connect-button.connected {
  background: #10b981;
  color: white;
}

.connect-button.disabled {
  background: #9ca3af;
  color: white;
  cursor: not-allowed;
}

.connect-button:disabled {
  cursor: not-allowed;
}

.status {
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  text-align: center;
}

.sync-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  background: white;
  border-radius: 50%;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  /* border: 1px solid #e5e7eb; */
}

.note-section {
  margin-bottom: 40px;
  text-align: center;
}

.note {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 14px;
  color: #6b7280;
  background: #fef3c7;
  padding: 12px 16px;
  border-radius: 8px;
  border: 1px solid #f59e0b;
}

.note-label {
  font-weight: 600;
  color: #92400e;
}

.features-section {
  margin-bottom: 40px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.features-section h2 {
  font-size: 20px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 20px;
  text-align: center;
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  color: #4b5563;
  background: white;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.feature-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #eff6ff;
  border-radius: 6px;
  flex-shrink: 0;
}

.actions-section {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 600px;
  margin: 0 auto;
}

.back-button,
.next-button {
  padding: 12px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button {
  background: white;
  color: #6b7280;
  border: 1px solid #d1d5db;
}

.back-button:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}

.next-button {
  background: #6b7280;
  color: white;
  border: 1px solid #6b7280;
}

.next-button:hover:not(:disabled) {
  background: #4b5563;
  border-color: #4b5563;
}

.next-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 768px) {
  .connect-accounts {
    padding: 20px;
  }

  .platforms-section {
    flex-direction: column;
    gap: 40px;
  }

  .sync-icon {
    order: -1;
    transform: rotate(90deg);
  }

  .platform-logo {
    width: 100px;
    height: 100px;
  }

  .actions-section {
    flex-direction: column;
  }

  .back-button,
  .next-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector/components/ConnectAccounts.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,8CAA8C;EAC9C,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,SAAS;IACT,wBAAwB;EAC1B;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".connect-accounts {\n  min-height: calc(100vh - 140px);\n  padding: 40px;\n  background: #f8fafc;\n}\n\n.connect-accounts-header {\n  text-align: center;\n  margin-bottom: 60px;\n}\n\n.connect-accounts-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  color: #1f2937;\n  margin-bottom: 12px;\n}\n\n.connect-accounts-header p {\n  font-size: 16px;\n  color: #6b7280;\n  max-width: 600px;\n  margin: 0 auto;\n  line-height: 1.6;\n}\n\n.platforms-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 60px;\n  margin-bottom: 40px;\n  max-width: 1000px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.platform-card {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.platform-logo {\n  width: 120px;\n  height: 120px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  border: 1px solid #e5e7eb;\n}\n\n.platform-logo img {\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.connect-button {\n  padding: 12px 32px;\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  min-width: 120px;\n}\n\n.connect-button.primary {\n  background: #3b82f6;\n  color: white;\n}\n\n.connect-button.primary:hover {\n  background: #2563eb;\n}\n\n.connect-button.connected {\n  background: #10b981;\n  color: white;\n}\n\n.connect-button.disabled {\n  background: #9ca3af;\n  color: white;\n  cursor: not-allowed;\n}\n\n.connect-button:disabled {\n  cursor: not-allowed;\n}\n\n.status {\n  font-size: 14px;\n  color: #6b7280;\n  font-weight: 500;\n  text-align: center;\n}\n\n.sync-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  background: white;\n  border-radius: 50%;\n  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */\n  /* border: 1px solid #e5e7eb; */\n}\n\n.note-section {\n  margin-bottom: 40px;\n  text-align: center;\n}\n\n.note {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 14px;\n  color: #6b7280;\n  background: #fef3c7;\n  padding: 12px 16px;\n  border-radius: 8px;\n  border: 1px solid #f59e0b;\n}\n\n.note-label {\n  font-weight: 600;\n  color: #92400e;\n}\n\n.features-section {\n  margin-bottom: 40px;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.features-section h2 {\n  font-size: 20px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.features-list {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  font-size: 14px;\n  color: #4b5563;\n  background: white;\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid #e5e7eb;\n}\n\n.feature-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  background: #eff6ff;\n  border-radius: 6px;\n  flex-shrink: 0;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: center;\n  gap: 16px;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.back-button,\n.next-button {\n  padding: 12px 32px;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button {\n  background: white;\n  color: #6b7280;\n  border: 1px solid #d1d5db;\n}\n\n.back-button:hover {\n  background: #f9fafb;\n  border-color: #9ca3af;\n}\n\n.next-button {\n  background: #6b7280;\n  color: white;\n  border: 1px solid #6b7280;\n}\n\n.next-button:hover:not(:disabled) {\n  background: #4b5563;\n  border-color: #4b5563;\n}\n\n.next-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n@media (max-width: 768px) {\n  .connect-accounts {\n    padding: 20px;\n  }\n\n  .platforms-section {\n    flex-direction: column;\n    gap: 40px;\n  }\n\n  .sync-icon {\n    order: -1;\n    transform: rotate(90deg);\n  }\n\n  .platform-logo {\n    width: 100px;\n    height: 100px;\n  }\n\n  .actions-section {\n    flex-direction: column;\n  }\n\n  .back-button,\n  .next-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
